export const projects = [
  {
    id: 'mitcham',
    name: 'Mitcham Townhouse Subdivision',
    suburb: 'Mitcham',
    category: 'Residential',
    status: 'Completed',
    featured: true,
    credential: 'From land assessment to settlement — one team, every stage.',
    description: 'Our first project, and still the clearest example of what we do. We reviewed the town planning documents before the land was purchased, produced the working drawings, guided the client through the building permit, and delivered interior and exterior renders along with marketing materials and the agent\'s kit. During construction we managed the project on the client\'s behalf, then handled handover and coordinated settlement for all five townhouses.',
    tags: ['Subdivision', 'Working Drawings', 'Project Management', 'Settlement'],
    imageSlot: 'texture-concrete',
    photos: [
      '/images/u018068_tp_03_.webp',
      '/images/u018068_01_tp.webp',
      '/images/u018068_tp_02_.webp',
      '/images/u018068_tp_04_.webp',
    ],
  },
  {
    id: 'ringwood',
    name: 'Ringwood Terrace Townhouses',
    suburb: 'Ringwood',
    category: 'Residential',
    status: 'VCAT Approved',
    featured: false,
    credential: 'VCAT-approved five-lot scheme on a 720sqm site.',
    description: 'On a 720sqm site, extensive research and interpretation of the planning scheme led to a five-lot double-storey semi-detached terrace scheme that maximised the client\'s investment return. Working alongside a well-respected town planner, the design met every requirement of the scheme, and our 3D sketches supported approval through VCAT.',
    tags: ['Subdivision', 'Town Planning', 'VCAT'],
    imageSlot: 'texture-stone',
    photos: [
      '/images/a018058_rev2_01_pitt_street_.webp',
      '/images/a018058_rev2_04_.webp',
      '/images/a018058_rev2_02_.webp',
      '/images/a018058_rev2_03_.webp',
    ],
  },
  {
    id: 'toorak-luxury',
    name: 'Toorak Luxury Residence',
    suburb: 'Toorak',
    category: 'Residential',
    status: 'Completed',
    featured: true,
    credential: 'Bespoke luxury living in Melbourne\'s most prestigious address.',
    description: 'A contemporary two-storey residence designed for refined family living. The home features a 20-metre swimming pool set within private landscaped gardens, full-height glazing throughout the ground floor for seamless indoor-outdoor flow, and an open-plan living pavilion with bespoke kitchen, dining, and entertaining spaces. The master suite occupies a dedicated wing with walk-in wardrobe and ensuite, while upper-level bedrooms enjoy balcony access and garden views. Stone, timber, and bronze detailing unify the interior palette.',
    tags: ['Luxury Residential', 'Pool & Landscape', 'Custom Interiors', 'Bespoke Joinery'],
    imageSlot: 'texture-stone',
    photos: [
      '/images/toorak_luxury_04_20swim.webp',
      '/images/toorak_luxury_01_.webp',
      '/images/toorak_luxury_05_.webp',
      '/images/toorak_luxury_06_.webp',
    ],
  },
  {
    id: 'yerring',
    name: 'Yerring Hotel & Function Facilities',
    suburb: 'Yering',
    category: 'Commercial',
    status: 'Approved',
    featured: false,
    credential: 'Function facility and rooftop venue in the Yarra Valley.',
    description: 'Approved designs extend the existing buildings and add a dedicated function facility and rooftop area for weddings and special events — set to become a hidden attraction of the local area.',
    tags: ['Hospitality', 'Function Space'],
    imageSlot: 'texture-timber',
    photos: [
      '/images/yering_gathering_hall_01_front_dusk.webp',
      '/images/yering_gathering_hall_02_rear_day.webp',
      '/images/yering_gathering_hall_03_long_side_blue_hour.webp',
    ],
  },
  {
    id: 'carlton',
    name: 'Carlton Cafe & Patisserie',
    suburb: 'Carlton',
    category: 'Commercial',
    status: 'Completed',
    featured: false,
    credential: 'First cafe — tight footprint, generous outcome.',
    description: 'A first cafe for a small-business owner, on a quiet street beneath an apartment building surrounded by offices and residences. Within a tight footprint we delivered a practical, low-maintenance shop with generous product display, comfortable staff working space, and seating for twelve.',
    tags: ['Retail Fit-Out', 'Hospitality'],
    imageSlot: 'texture-terrazzo',
    photos: [
      '/images/u018067_cafe_01_.webp',
      '/images/u018067_cafe_02_.webp',
      '/images/u018067_cafe_03_.webp',
      '/images/u018067_cafe_04_.webp',
    ],
  },
  {
    id: 'preston-karaoke',
    name: 'Yering Hotel Renovation and Extension Works',
    suburb: 'Yering',
    category: 'Commercial',
    status: 'Completed',
    featured: false,
    credential: 'Seventeen acoustically-treated rooms from a former dance club.',
    description: 'Converted from a former dance club into seventeen rooms: seven small (up to 6 guests), five medium (up to 10), four large (up to 15) and a VIP room seating 20. Each room carries its own colour scheme, and acoustic treatment prevents sound carrying between rooms or disturbing neighbouring businesses. Reception doubles as a waiting area and bar.',
    tags: ['Retail Renovation', 'Acoustic Design'],
    imageSlot: 'texture-concrete',
    photos: [
      '/images/yering_hotel_01_aerial_golden_hour.webp',
      '/images/yering_hotel_02_reception_arrival_dusk.webp',
      '/images/yering_hotel_03_courtyard_guest_wing_day.webp',
      '/images/yering_hotel_04_luxury_reception_lounge.webp',
      '/images/yering_hotel_05_luxury_guest_suite.webp',
    ],
  },
  {
    id: 'maintstra',
    name: 'Maintstra — AI Property Maintenance',
    suburb: 'Melbourne',
    category: 'Digital',
    status: 'Launching',
    featured: false,
    subLabel: 'app',
    credential: 'AI platform that photographs, diagnoses, and dispatches.',
    description: 'An AI maintenance manager we designed and built end-to-end. Owners photograph a problem; the platform diagnoses it, drafts the request, reaches the right contractor and tracks the job to completion.',
    tags: ['Product Design', 'Mobile App', 'AI'],
    imageSlot: 'texture-dark',
    photos: [
      '/images/maintstra-product-home.webp',
      '/images/maintstra-product-ai-diagnosis.webp',
      '/images/maintstra-product-quotes.webp',
      '/images/maintstra-product-web-dashboard.webp',
    ],
  },
  {
    id: 'ledgeraxis-agent',
    name: 'LedgerAxis AI Agent',
    suburb: 'Melbourne',
    category: 'Digital',
    status: 'Launching',
    featured: false,
    subLabel: 'AI Agent',
    credential: 'Scale your practice, not your hours.',
    description: 'More clients. Same team. The volume work, handled. The judgement, still yours. Custom built AI Bookkeeping agents.',
    tags: ['Product Design', 'AI Agents', 'Bookkeeping'],
    imageSlot: 'texture-dark',
  },
  {
    id: 'nexa-pods',
    name: 'Nexa Pods — Modular Housing Brand',
    suburb: 'Melbourne',
    category: 'Digital',
    status: 'Live',
    featured: false,
    subLabel: 'website',
    credential: 'Brand identity and website for modular housing.',
    description: 'Brand identity and website for a modular housing product.',
    tags: ['Branding', 'Web Design'],
    imageSlot: 'texture-dark',
    photos: [
      '/images/nexapods_web_01_homepage_hero.webp',
      '/images/nexapods_web_02_responsive_devices.webp',
      '/images/nexapods_web_03_product_range_experience.webp',
      '/images/nexapods_web_04_design_system_overview.webp',
    ],
  },
];

export const serviceGroups = [
  {
    title: 'Building Design',
    path: '/residential-development-design-melbourne',
    icon: 'ri-draft-line',
    intro: 'From concept sketch to construction documentation — designs that work as hard as you do.',
    items: [
      'Master Planning & Feasibility',
      'Concept Design & 3D Visualization',
      'Town Planning Documentation',
      'Working Drawings & Detailing',
      'Heritage Overlay Design',
      'Multi-Unit Residential Projects',
      'Commercial & Mixed-Use',
    ],
    imageUrl: "/images/service-building-design-studio-optimized.webp",
  },
  {
    title: 'Interior Design',
    path: '/interior-design-melbourne',
    icon: 'ri-paint-brush-line',
    intro: 'Spaces that sell — curated interiors that speak to buyers before they walk through the door.',
    items: [
      'Residential Interior Design',
      'Retail & Hospitality Fit-Outs',
      'Space Planning & Layout',
      'Custom Joinery Design',
      'FF&E Selection & Schedules',
      'Material & Finish Palettes',
      'Lighting Design & Specification',
    ],
    imageUrl: "/images/service-interior-design.webp",
  },
  {
    title: 'Project Management',
    path: '/planning-project-management-melbourne',
    icon: 'ri-flow-chart',
    intro: 'We keep the wheels turning — from council submission to handover, every milestone managed.',
    items: [
      'Development & Project Management',
      'Builder Tender & Selection',
      'Council Negotiation & Liaison',
      'VCAT Representation',
      'Construction Phase Services',
      'Settlement Coordination',
      'Strata Consultation',
    ],
    imageUrl: "/images/service-project-management-optimized.webp",
  },
  {
    title: 'Branding & Marketing',
    path: null,
    icon: 'ri-megaphone-line',
    intro: 'Every project tells a story. We write it, design it, and put it in front of the right buyers.',
    items: [
      'Project Branding & Identity',
      'Sales Brochures & Collateral',
      'Agent Kit Design & Production',
      'Photography Art Direction',
      'Signage & Hoarding Design',
      'Display Suite Experience',
      'Campaign Strategy & Assets',
    ],
    imageUrl: "/images/nexapods_web_02_responsive_devices.webp",
  },
  {
    title: 'Digital & Technology',
    path: null,
    icon: 'ri-smartphone-line',
    intro: 'Property meets product design — digital tools that work as hard as the development itself.',
    items: [
      'Project Sales Websites',
      'Buyer Portals & Dashboards',
      'Mobile Applications',
      'Custom AI Agents & Automation',
      'Virtual Tours & 3D Walkthroughs',
      'CRM Integration & Lead Management',
      'Post-Settlement Owner Platforms',
    ],
    imageUrl: "/images/service-digital-maintstra.webp",
  },
];

export const mapSuburbs = [
  { name: 'Mitcham', lat: -37.817, lng: 145.193 },
  { name: 'Ringwood', lat: -37.811, lng: 145.231 },
  { name: 'Toorak', lat: -37.84, lng: 145.02 },
  { name: 'Preston', lat: -37.740, lng: 145.008 },
  { name: 'Carlton', lat: -37.800, lng: 144.969 },
  { name: 'Yerring', lat: -37.693, lng: 145.386 },
  { name: 'Kew', lat: -37.809, lng: 145.035 },
  { name: 'Hawthorn', lat: -37.822, lng: 145.036 },
  { name: 'Camberwell', lat: -37.841, lng: 145.069 },
  { name: 'Doncaster', lat: -37.788, lng: 145.123 },
  { name: 'Box Hill', lat: -37.819, lng: 145.123 },
  { name: 'Glen Waverley', lat: -37.877, lng: 145.165 },
];

export const stats = [
  { value: 15, suffix: '+', label: 'Years Experience' },
  { value: 100, suffix: '%', label: 'End-to-End Service' },
];
